/** Backend provider: `azure` (legacy) or `supabase` */
export const BACKEND = (process.env.REACT_APP_BACKEND || "azure").toLowerCase();

export function isSupabaseBackend() {
  return BACKEND === "supabase";
}

export function isAzureBackend() {
  return BACKEND !== "supabase";
}
